import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import PracticeTest from './views/PracticeTest.vue';
import Suggest from './views/Suggest.vue';
import Report from './views/Report.vue';
import CustomQuiz from './views/CustomQuiz';
import Resources from './views/Resources';
import About from './views/About';
import Imprint from './views/Imprint';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/scrum-master-practice-test',
      name: 'sm',
      component: PracticeTest,
      props: { quizData: window.QuizSM },
    },
    {
      path: '/product-owner-practice-test',
      name: 'po',
      component: PracticeTest,
      props: { quizData: window.QuizPO },
    },
    {
      path: '/resources',
      name: 'resources',
      component: Resources,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/imprint',
      name: 'imprint',
      component: Imprint,
    },
    {
      path: '/suggest',
      name: 'suggest',
      component: Suggest,
    },
    {
      path: '/report/:id',
      name: 'report',
      component: Report,
    },
    {
      path: '/customize',
      name: 'customize',
      component: CustomQuiz,
    },
  ],
});
